import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UserService } from '@teem/app/core/services/user.service';

@Component({
  selector: 'whatsapp-notification',
  templateUrl: './whatsapp-notification.component.html',
  styleUrls: ['./whatsapp-notification.component.scss']
})
export class WhatsappNotificationComponent implements OnInit {

  whatsappNotificationEnabled: boolean = false;
  userDetails: any = {};
  constructor(private userService: UserService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  @Input('userDetails')
  set getInfo(val: any) {
    this.userDetails = val;
    this.whatsappNotificationEnabled = (this.userDetails?.enable_whatsapp_notification == 1 ? true : false);
    this.cdr.detectChanges();
  }

  updateWhatsappTab(event) {
    let status: boolean = false;
    status = !event.target.checked;
    this.updateWhatsapp(status);
  }

  updateWhatsapp(status) {
    this.userService.updatePaymentOption({ 'enable_whatsapp_notification': status }).subscribe(
      (res: any) => {
        this.whatsappNotificationEnabled = (res.data.enable_whatsapp_notification == true ? true : false);
        this.cdr.detectChanges();
      });
  }

}
